export const ROUTES = {
    salesOrders: '/sales-orders',
    salesOrdersDetail: '/sales-orders/:id',
    purchaseOrders: '/purchase-orders',
    purchaseOrdersDetail: '/purchase-orders/:id',
    inquiries: '/inquiries',
    inquiriesDetail: '/inquiries/:id',
    demands: '/demands',
    demandsDetail: '/demands/:id',
    dashboard: '/dashboard',
    invoices: {
        list: '/invoices',
        detail: '/invoices/:id',
    },
    configuration: {
        data: '/configuration/data',
        finance: '/configuration/finance',
        organization: '/configuration/organization',
        accounting: '/configuration/accounting',
        search: '/configuration/search',
    },
    settings: '/settings',
    bonusSettlements: {
        overview: '/bonus-settlements',
        detail: {
            base: '/bonus-settlements/:id',
            supplier: '/bonus-settlements/:id/supplier',
            customer: '/bonus-settlements/:id/customer',
        },
        supplierDetail: '/bonus-settlements/:bonusSettlementId/supplier/details/:id',
        customerDetail: '/bonus-settlements/:bonusSettlementId/customer/details/:id',
    },
    products: {
        product: {
            base: '/products/product',
            detail: '/products/product/:id',
            new: '/products/product/new',
        },
        import: {
            overview: {
                base: '/products/import',
                all: '/products/import/all',
                supplier: '/products/import/supplier',
            },
            // base: '/products/import',
            detail: '/products/import/all/:id',
        },
        mapping: {
            base: '/products/mapping',
            categories: 'categories',
            units: 'units',
            attributes: 'attributes',
        },
    },
    contactsAndOrganizations: {
        customers: {
            list: '/customers',
            detail: '/customers/:id',
            new: '/customers/new',
        },
        suppliers: {
            list: '/suppliers',
            detail: '/suppliers/:id',
            new: '/suppliers/new',
        },
        contacts: {
            list: '/contacts',
            detail: '/contacts/:id',
            new: '/contacts/new',
        },
    },
    contentManagement: {
        headerBanner: {
            list: '/content-management/header-banner',
            detail: '/content-management/header-banner/:id',
        },
        sponsorBanner: {
            list: '/content-management/sponsor-banner',
            detail: '/content-management/sponsor-banner/:id',
        },
        supplierSpecialOffers: {
            list: '/content-management/supplier-special-offers',
            detail: '/content-management/supplier-special-offers/:id',
            shop: '/view',
        },
        poolNews: {
            list: '/content-management/pool-news',
            detail: '/content-management/pool-news/:id',
        },
        staticSites: {
            list: '/content-management/static-sites',
            detail: '/content-management/static-sites/:id',
        },
        footer: '/content-management/footer',
    },
};
